// extracted by mini-css-extract-plugin
export default {"page":"Entrance_page__6x-zc","card":"Entrance_card__7wXGM"};